<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VnPSwO/tc-custom/9781481406185.jpg?1730530305655" alt="This image is the cover for the book Coconut Clue, Candy Fairies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Coconut Clue, Candy Fairies
      </h1>
      <p class="bookDescription body article font2">
        <b>The Candy Fairies go on a gummy-tastic adventure full of flavor when they discover a tropical lagoon—with a tropical treasure!</b><br/><br/>Raina the Gummy Fairy wants to discover new flavors for her gummy candy. On the far side of Gummy Forest there’s a lagoon where she finds tropical gummy flavors that she has only read about—pineapple, mango, and tangerine! But how are these yummy flavors made? Is there a hidden secret? The fairies start to harvest the new treats and notice signs of some ancient artifacts. Could they be the key to these tropical treats?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Perelman
      </h2>
      
      <p class="authorDescription body article">Helen Perelman has&#160;worked in a children&rsquo;s bookstore and was a children&rsquo;s book editor. She now writes full-time in New York, where she lives with her husband and two daughters. Visit her online at HelenPerelman.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d0361ed